module.exports = __webpack_public_path__ + "img/request_myinfo.337dfed1.svg";